module.exports = __webpack_public_path__ + "img/goodsB2.6634a13a.png";